import { useMemo } from "react";
import PdfStyledTable from "../../pdfBuilder/components/data/PdfStyledTable";

const PdfGenericDataTable = ({ data, title }) => {
  const columnDefs = useMemo(
    () => [
      { headerName: "Field", field: "fieldLabel" },
      { headerName: "Value", field: "value" },
    ],
    []
  );
  if (!data) return null;

  return <PdfStyledTable columnDefs={columnDefs} data={data} />;
};

export default PdfGenericDataTable;
